import { BRAND } from '../brand/brand.data';

export const NAVIGATIONS = {

  // Landing layout
  root: {
    url: '',
    // Title and description within the SERP limits (~60 / ~160 chars; the old pair ran 125 / 427 and
    // was cut mid-sentence in every result). Mirrors ROUTE_SEO['/'] in seo-route-meta.js.
    title: 'Codigrate - Themes, Color Palettes & Vibe Coding Tools',
    description: 'Premium IDE themes, color palettes and free hex color tools for JetBrains, Xcode, VS Code, Cursor, Zed, Chrome, Firefox, Slack, Ghostty, iTerm2, Sublime Text and Rhino.',
    keywords: [
      'codigrate', 'vibe coding', 'vibe code', 'themes', 'ide themes',
      'color palette', 'palette generator', 'hex', 'hex code', 'hex color', 'color codes',
      'jetbrains', 'jetbrains marketplace', 'jetbrains plugins', 'jetbrains themes',
      'vs code', 'vs code marketplace', 'vscode themes',
      'chrome extensions', 'chrome web store',
      'firefox themes', 'firefox add-ons',
      'cursor', 'cursor marketplace', 'cursor themes',
      'antigravity', 'antigravity marketplace',
      'slack', 'slack apps', 'slack themes',
      'ghostty', 'ghostty marketplace', 'ghostty themes', 'terminal themes',
      'sublime text', 'sublime text themes', 'package control',
      'software consultancy', 'software integration', 'api integration', 'workflow automation',
      'mobile app development',
      'payment gateway integration', 'stripe integration', 'hire developers'
    ],
  },
  notFound: {
    url: 'not-found',
    title: 'Not Found',
    description: BRAND.name + ` Not Found`,
    keywords: [ 'not found' ],
  },
  maintenance: {
    url: 'maintenance',
    title: 'Maintenance',
    description: BRAND.name + ` Maintenance`,
    keywords: [ 'maintenance' ],
  },
  signupSuccess: {
    url: 'signup-success',
    title: 'Sign Up Success',
    description: 'Congratulations! You have successfully signed up with ' + BRAND.name + '.',
    keywords: [ 'sign up', 'success' ],
  },
  verifyAccount: {
    url: 'verify-account',
    title: 'Verify Account',
    description: 'Verify your account at ' + BRAND.name + ' to access all features.',
    keywords: [ 'verify account', 'activation' ],
  },
  cookiePolicy: {
    url: 'cookie-policy',
    title: 'Cookie Policy',
    description: 'Learn about the cookie policy at ' + BRAND.name + ' and how we use cookies.',
    keywords: [ 'cookie policy', 'cookies' ],
  },
  privacyPolicy: {
    url: 'privacy-policy',
    title: 'Privacy Policy',
    description: 'Read the privacy policy of ' + BRAND.name,
    keywords: [ 'privacy policy', 'data protection' ],
  },
  terms: {
    url: 'terms',
    title: 'Terms',
    description: 'View the terms and services of ' + BRAND.name + ' to understand our policies.',
    keywords: [ 'terms and services', 'policies' ],
  },
  langmi: {
    url: 'langmi',
    title: 'LangMi: Learn a Language by Living a Story',
    description: 'A story-based language app for iPhone and iPad: learn English in London through real dialogues, real voices, mini games and lessons with your teacher.',
    keywords: [
      'langmi', 'language learning app', 'learn english app', 'learn english through stories', 'story based language learning',
      'english for beginners', 'a1 english', 'speak english app', 'english speaking practice', 'vocabulary app',
      'spaced repetition', 'language games', 'learn with your teacher', 'iphone app', 'ipad app', 'codigrate'
    ],
  },
  langmiPrivacy: {
    url: 'langmi/privacy-policy',
    title: 'LangMi Privacy Policy',
    description: 'How the LangMi mobile app handles your data: on your device by default, on our EU servers only if you sign in.',
    keywords: [ 'langmi', 'privacy policy', 'mobile app', 'data protection' ],
  },
  langmiTerms: {
    url: 'langmi/terms',
    title: 'LangMi Terms of Use',
    description: 'Terms of Use and subscription terms for the LangMi mobile app by ' + BRAND.name + '.',
    keywords: [ 'langmi', 'terms of use', 'eula', 'subscription' ],
  },
  langmiTeacherTerms: {
    url: 'langmi/teacher-terms',
    title: 'LangMi Teacher Terms',
    description: 'Terms for the teacher profile of the LangMi mobile app by ' + BRAND.name + ': learn together, notes, students who are minors.',
    keywords: [ 'langmi', 'teacher terms', 'teacher profile', 'learn together' ],
  },
  themeLicense: {
    url: 'theme/license',
    title: 'Theme License - Standard EULA of the Paid JetBrains Theme Plugins',
    description: 'Standard EULA of the paid theme plugins for JetBrains IDEs by ' + BRAND.name + ': the All In One Themes subscription license and the one-time perpetual license of each standalone premium theme.',
    keywords: [ 'theme license', 'eula', 'jetbrains plugin', 'all in one themes', 'premium theme', 'perpetual license', 'subscription' ],
  },
  themePrivacy: {
    url: 'theme/privacy',
    title: 'Theme Privacy Policy - Paid JetBrains Theme Plugins',
    description: 'Privacy policy of the paid theme plugins for JetBrains IDEs by ' + BRAND.name + ': the plugin collects, stores and transmits no personal or usage data and uses no analytics or external services.',
    keywords: [ 'theme privacy policy', 'jetbrains plugin privacy', 'all in one themes', 'premium theme', 'no data collection' ],
  },
  signup: {
    url: 'signup',
    title: 'Sign Up',
    description: 'Sign up with ' + BRAND.name + ' to get started with our services.',
    keywords: [ 'sign up', 'registration' ],
  },
  login: {
    url: 'login',
    title: 'Login',
    description: 'Login to your account at ' + BRAND.name + ' to access our services.',
    keywords: [ 'login', 'account access' ],
  },
  branding: {
    url: 'branding',
    title: 'Branding',
    description: 'Learn about ' + BRAND.name + ' branding.',
    keywords: [ 'branding', 'business identity' ],
  },
  blog: {
    url: 'blog',
    title: 'Blog',
    description: 'Color theory, palette harmony, the places behind our themes, the platforms we publish to, and our open-source work - from ' + BRAND.name + '.',
    keywords: [ 'blog', 'articles', 'color theory', 'color palette', 'palette harmony', 'ide themes', 'vibe coding' ],
  },
  themes: {
    url: 'themes',
    title: 'IDE Color Themes for JetBrains, Xcode, VS Code & More | Codigrate',
    description: 'Premium and free IDE color themes for JetBrains, Xcode, VS Code, Cursor, Zed, Chrome, Firefox, Slack, Ghostty, iTerm2, Sublime Text and Rhino 3D. Dark and light, WCAG-checked.',
    keywords: [
      'themes', 'ide themes', 'editor themes', 'color schemes', 'vibe coding', 'vibe code themes',
      'jetbrains themes', 'jetbrains marketplace', 'jetbrains plugins',
      'vs code themes', 'vs code marketplace', 'vscode themes',
      'cursor themes', 'cursor marketplace',
      'antigravity themes', 'antigravity marketplace',
      'chrome extensions', 'chrome web store',
      'firefox themes', 'firefox add-ons',
      'slack themes', 'slack apps',
      'ghostty themes', 'ghostty marketplace', 'terminal themes',
      'sublime text themes', 'package control',
      'color palette', 'palette generator', 'hex', 'hex code', 'color codes'
    ],
  },
  palettes: {
    url: 'palettes',
    title: 'Color Palettes - 24 Named Colors per Theme, Free to Download',
    description: 'Download free color palettes by Codigrate: every theme distilled into curated, named colors, from Polar Night to Golden Horn. Native palette files for the platforms you design on, MacOS first and more on the way. Copy hex codes with one click.',
    keywords: [
      'color palettes', 'palettes', 'color palette download', 'named colors',
      'macos color palette', 'macos color picker', 'clr file', 'nscolorlist', 'apple color list',
      'hex', 'hex codes', 'color codes', 'color swatches', 'swatch library',
      'design palettes', 'ui color palette', 'dark theme palette', 'light theme palette',
      'aurora borealis palette', 'tokyo palette', 'istanbul palette', 'sakura palette',
      'codigrate', 'vibe coding'
    ],
  },
  theme: {
    url: 'theme',
    title: 'Theme Details - Install on JetBrains, VS Code, Cursor, Antigravity, Chrome, Slack, Ghostty & Sublime Text',
    description: 'Install Codigrate themes on JetBrains Marketplace, VS Code Marketplace, Cursor Marketplace, Antigravity Marketplace, Chrome Web Store, Slack, Ghostty and Sublime Text. Preview screenshots, color palette, hex codes and color blindness simulation.',
    keywords: [
      'theme', 'ide theme', 'color palette', 'hex', 'hex code', 'color codes',
      'jetbrains marketplace', 'vs code marketplace', 'cursor marketplace',
      'antigravity marketplace', 'chrome web store',
      'slack apps', 'ghostty marketplace', 'sublime text themes', 'vibe coding'
    ],
  },
  screenshots: {
    url: 'screenshots',
    title: 'Theme Screenshots - JetBrains, VS Code, Cursor, Antigravity & More',
    description: 'High-resolution screenshots of Codigrate themes running in JetBrains IDEs, VS Code, Cursor, Antigravity, Chrome, Slack, Ghostty terminal and Sublime Text.',
    keywords: [
      'screenshots', 'theme screenshots', 'ide screenshots',
      'jetbrains', 'vs code', 'cursor', 'antigravity', 'chrome', 'slack', 'ghostty', 'sublime text',
      'color palette', 'vibe coding'
    ],
  },
  pinterest: {
    url: 'pinterest',
    title: 'Pinterest Pins - Codigrate Theme Cards',
    description: 'Private gallery of Pinterest-ready pin cards for Codigrate themes: stacked screenshots and color palettes in a 2:3 pin format.',
    keywords: [ 'pinterest', 'pins', 'theme cards', 'color palette', 'screenshots' ],
  },
  line: {
    url: 'line',
    title: 'LINE Theme Previews - Codigrate',
    description: 'Private gallery of LINE-theme chat mockups for Codigrate themes: each theme rendered as a LINE chat screen inside an iPhone frame, ready to screenshot.',
    keywords: [ 'line', 'line theme', 'chat preview', 'theme mockup', 'screenshots' ],
  },
  forgetPassword: {
    url: 'forget-password',
    title: 'Forget Password',
    description: 'Forgot your password?',
    keywords: [ 'password recovery', 'forgot password' ],
  },
  resetPassword: {
    url: 'reset-password',
    title: 'Reset Password',
    description: 'Reset your password for ' + BRAND.name + ' to enhance security.',
    keywords: [ 'reset password', 'security' ],
  },
  contactUs: {
    url: 'contact-us',
    title: 'Contact Us',
    description: 'Get in touch with ' + BRAND.name + ' for any queries or feedback.',
    keywords: [ 'contact us', 'queries', 'feedback' ],
  },
  // Store (premium theme downloads sold on the site: cart -> Stripe Checkout
  // -> order page, see base-themes/STORE-DESIGN.md). All three are noindex
  // (seo-route-meta.js): transient, per-visitor pages.
  cart: {
    url: 'cart',
    title: 'Your Cart',
    description: 'The premium themes you picked. Pay once with Stripe and download them right away.',
    keywords: [ 'cart', 'checkout', 'premium themes', 'buy theme' ],
  },
  order: {
    url: 'order',
    title: 'Your Order',
    description: 'Your Codigrate order: download your themes, the install steps and your receipt.',
    keywords: [ 'order', 'download', 'premium themes' ],
  },
  orderFind: {
    url: 'order/find',
    title: 'Find My Order',
    description: 'Lost your download link? Get the links of your Codigrate orders e-mailed again.',
    keywords: [ 'find order', 'download link', 'order lookup' ],
  },
  storeTerms: {
    url: 'store/terms',
    title: 'Terms of Sale',
    description: 'The terms of sale of the premium theme downloads on codigrate.com: delivery, licence, no refunds, and your rights.',
    keywords: [ 'terms of sale', 'licence', 'refund policy', 'digital download', 'premium themes' ],
  },
  status: {
    url: 'status',
    title: 'Status',
    description: 'Check the current status of ' + BRAND.name + ' services and systems.',
    keywords: [ 'status', 'service status' ],
  },
  sitemap: {
    url: 'sitemap',
    title: 'Sitemap',
    description: 'Navigate through the sitemap of ' + BRAND.name + ' for easy access to all pages.',
    keywords: [ 'sitemap', 'site structure' ],
  },
  u: {
    url: 'u',
    title: 'User',
    description: 'Manage your user profile at ' + BRAND.name,
    keywords: [ 'user profile', 'personalization' ],
  },
  softwareConsultancy: {
    url: 'software-consultancy',
    title: 'Software Consultancy',
    description: 'Get expert software consultancy services from ' + BRAND.name + ' for your projects.',
    keywords: [ 'software consultancy', 'consulting services' ],
  },
  softwareIntegration: {
    url: 'software-integration',
    title: 'Software Integration',
    description: 'Integrate your software systems seamlessly with ' + BRAND.name + ' integration services.',
    keywords: [ 'software integration', 'integration services' ],
  },
  qualityAssurance: {
    url: 'quality-assurance',
    title: 'Quality Assurance',
    description: 'Ensure high quality in your software projects with ' + BRAND.name + ' QA services.',
    keywords: [ 'quality assurance', 'QA services' ],
  },

  // the AI cost calculator under /tools (owner 2026-10-19: no /ai area, an AI Tools section on /tools)
  aiPriceWatch: {
    url: 'ai-price-watch',
    title: 'AI Price Watch - LLM Token Price Chart and Tracker',
    description: 'Track the token price of every Claude, GPT, Gemini, Grok, Mistral and DeepSeek model on a daily price chart: input, output and cached input per million tokens, the change over 1, 3 and 6 months, YTD and a year.',
    keywords: [
      'ai price watch', 'ai price tracker', 'ai price chart', 'llm price tracker', 'llm price chart', 'llm price history', 'ai token price',
      'token price chart', 'ai model prices', 'llm pricing comparison', 'claude price history', 'claude api price', 'gpt price history',
      'openai api price', 'gemini api price', 'price per million tokens', 'codigrate'
    ],
  },
  aiCostCalculator: {
    url: 'ai-cost-calculator',
    title: 'AI API Cost Calculator - Monthly Cost of Claude, GPT and Gemini Requests',
    description: 'Pick what you are building, a chatbot, a coding assistant or document summaries, and see what it costs a month on every Claude, GPT, Gemini, Grok, Mistral and DeepSeek model. Prices updated every day.',
    keywords: [
      'ai cost calculator', 'llm cost calculator', 'openai cost calculator', 'claude cost calculator', 'gpt cost calculator', 'gemini cost calculator',
      'token cost calculator', 'api cost estimate', 'llm api monthly cost', 'ai budget', 'codigrate'
    ],
  },

  // Tools Layout
  tools: {
    url: 'tools',
    title: 'Free Color Tools, Generators & Converters - Hex, RGB, HSL',
    description: 'Free color tools: the Color Explorer, palette, gradient and wallpaper generators, and 30 color converters between HEX and RGB, HSL, OKLCH, CIELUV and more.',
    keywords: [
      'tools', 'color tools', 'color explorer', 'generators', 'converters', 'web-tools', 'utilities',
      'hex', 'hex code', 'hex color', 'color codes',
      'palette', 'color palette', 'palette generator', 'gradient generator', 'wallpaper generator',
      'color converter', 'hex to rgb', 'rgb to hex', 'hex to hsl', 'hsl to hex', 'hex to oklch', 'hex to cieluv',
      'vibe coding', 'codigrate'
    ],
  },
  plugins: {
    url: 'plugins',
    title: 'Apps & Plugins for the Tools You Use - Codigrate',
    description: 'Codigrate apps, plugins and extensions to boost your productivity. The Color Picker eyedropper for Chrome, JetBrains IDEs and VS Code, and the Color Picker app for macOS.',
    keywords: [
      'apps', 'plugins', 'extensions', 'browser extensions', 'chrome extensions', 'jetbrains plugins', 'vs code extensions',
      'macos apps', 'mac app', 'menu bar app',
      'color picker extension', 'color picker plugin',
      'vibe coding', 'codigrate'
    ],
  },
  color: {
    url: 'color',
    title: 'Free Color Explorer - Hex to RGB, HSL, OKLCH, RAL & Contrast',
    description: 'Free color explorer by Codigrate. Type any hex code for its RGB, HSL, CMYK, LAB and OKLCH values, the nearest RAL color, WCAG and APCA contrast and color blindness.',
    keywords: [
      'color', 'color explorer', 'hex', 'hex code', 'hex color', 'color codes',
      'rgb', 'hsl', 'hsv', 'cmyk', 'lab', 'oklch', 'oklab', 'hwb',
      'color converter', 'color picker',
      'wcag', 'apca', 'contrast ratio', 'contrast checker', 'color contrast', 'readability',
      'color schemes', 'complementary', 'split complementary', 'triadic', 'tetradic', 'analogous', 'monochrome',
      'palette examples', 'color palette', 'palette generator',
      'accessibility', 'color blindness',
      'Protanomaly', 'Deuteranomaly', 'Protanopia', 'Deuteranopia', 'Tritanopia', 'Achromatomaly', 'Achromatopsia',
      'vibe coding'
    ],
  },
  palette: {
    url: 'palette',
    title: 'Color Palette Generator - Free Hex Palette Maker & Color Codes',
    description: 'Free color palette generator by Codigrate. Build a palette by hand, extract one from an image, or generate complementary, split, triadic, tetradic, analogous, monochrome, warm and cool schemes from any color, a Codigrate theme or a shareable seed. Convert every color to RGB, HSL, CMYK and OKLCH, analyze harmony and temperature, preview readability with WCAG and APCA, and simulate color blindness for accessible vibe coding designs.',
    keywords: [
      'palette', 'color palette', 'palette generator', 'palette maker',
      'hex', 'hex code', 'color codes',
      'complementary', 'split complementary', 'triadic', 'tetradic', 'analogous', 'monochrome', 'warm palette', 'cool palette',
      'rgb', 'hsl', 'cmyk', 'oklch', 'color conversion', 'color temperature',
      'image palette', 'palette from image', 'random palette',
      'design', 'color matching', 'color harmony',
      'accessibility', 'color blindness',
      'Protanomaly', 'Deuteranomaly', 'Protanopia', 'Deuteranopia', 'Tritanopia', 'Achromatomaly', 'Achromatopsia',
      'vibe coding', 'codigrate'
    ],
  },
  colorPalette: {
    url: 'palette',
    title: 'Color Palette Details - Named Colors, Hex Codes & Downloads',
    description: 'Explore a Codigrate theme palette in detail: curated, named colors with hex codes, platform previews and free palette downloads, MacOS first and more on the way.',
    keywords: [
      'color palette', 'palette', 'named colors', 'hex codes', 'color codes',
      'macos color palette', 'macos color picker', 'clr file', 'color swatches',
      'palette download', 'design palette', 'codigrate'
    ],
  },
  gradient: {
    url: 'gradient',
    title: 'CSS Gradient Generator - Free Linear, Radial & Conic Gradient Maker',
    description: 'Free CSS gradient generator by Codigrate. Build linear, radial and conic gradients from your own color stops, set the angle, and copy ready-to-use CSS for your designs.',
    keywords: [
      'css gradient generator', 'gradient generator', 'gradient maker',
      'linear gradient', 'radial gradient', 'conic gradient',
      'css gradient', 'css background', 'color stops', 'background gradient',
      'vibe coding', 'codigrate'
    ],
  },
  wallpaper: {
    url: 'wallpaper',
    title: 'Wallpaper Generator - Free Procedural Wallpapers From Any Palette',
    description: 'Free wallpaper generator by Codigrate. Turn any color palette into a mesh, wave, aurora, low poly, stripe, orb, mountain, synthwave, circuit, forest, checkered, hexagon, terrazzo, isometric, Bauhaus or dune wallpaper and download it for 4K, 5K, ultrawide, MacBook, iPhone, Android and iPad in one click.',
    keywords: [
      'wallpaper generator', 'procedural wallpaper', 'gradient wallpaper', 'mesh gradient wallpaper',
      'aurora wallpaper', 'low poly wallpaper', '4k wallpaper', '5k wallpaper', 'iphone wallpaper',
      'android wallpaper', 'desktop wallpaper', 'color palette wallpaper', 'codigrate'
    ],
  },
  dynamicWallpaper: {
    url: 'dynamic-wallpaper',
    title: 'Free macOS Dynamic Wallpaper Generator - Download HEIC',
    description: 'Free macOS dynamic wallpaper generator by Codigrate. Turn any color palette into a wallpaper lit for every hour, from sunrise to night, and download one .heic that changes with the time of day, the sun position or Light and Dark mode.',
    keywords: [
      'dynamic wallpaper', 'macos dynamic wallpaper', 'dynamic wallpaper generator', 'mac dynamic wallpaper',
      'heic wallpaper', 'dynamic desktop', 'light and dark wallpaper', 'time of day wallpaper',
      'sun position wallpaper', 'mac wallpaper', '5k wallpaper', 'codigrate'
    ],
  },
  colorBlindnessSimulator: {
    url: 'color-blindness-simulator',
    title: 'Color Blindness Simulator - Free, For Any Image',
    description: 'Free color blindness simulator by Codigrate. Upload any image and see it through protanopia, deuteranopia, tritanopia, achromatopsia and four more conditions, side by side. Made in your browser, nothing uploaded.',
    keywords: [
      'color blindness simulator', 'color blind simulator', 'colorblind simulator', 'color blindness test image', 'protanopia simulator',
      'deuteranopia simulator', 'tritanopia simulator', 'achromatopsia simulator', 'cvd simulator', 'accessibility', 'codigrate'
    ],
  },
  contrastChecker: {
    url: 'contrast-checker',
    title: 'Free Contrast Checker - WCAG Color Contrast Ratio for Text',
    description: 'Free WCAG contrast checker by Codigrate. Check the contrast ratio of any text and background color for AA and AAA, large text and UI parts, see APCA, and get the closest colors that pass.',
    keywords: [
      'contrast checker', 'color contrast checker', 'wcag contrast checker', 'contrast ratio', 'color contrast ratio', 'accessibility contrast checker',
      'wcag aa contrast', 'wcag aaa contrast', 'text contrast checker', 'apca contrast', 'accessible colors', 'codigrate'
    ],
  },
  codeImage: {
    url: 'code-snippet',
    title: 'Free Code Snippet Image Generator - Code to PNG in 25 Themes',
    description: 'Free code snippet image generator by Codigrate. Paste your code, pick a language and one of 24 editor themes, and download a sharp PNG of your snippet for social posts, slides, docs and READMEs.',
    keywords: [
      'code snippet image generator', 'code snippet generator', 'code image generator', 'code to image', 'code to png', 'code screenshot', 'code snippet image',
      'beautiful code screenshots', 'syntax highlighting image', 'share code as image', 'codigrate'
    ],
  },
  hexToRgb: {
    url: 'hex-to-rgb',
    title: 'Free HEX to RGB Converter - Hex Color Codes to RGB',
    description: 'Free HEX to RGB converter by Codigrate. Paste any hex color code and instantly get its rgb() value, with a live preview, a color picker and the math worked out step by step. HEX and RGB are the same color in two notations.',
    keywords: [
      'hex to rgb', 'hex to rgb converter', 'convert hex to rgb', 'hex to rgb color',
      'hex code to rgb', 'hexadecimal to rgb', 'hex rgb', 'color converter',
      'hex color code', 'rgb color', 'vibe coding', 'codigrate'
    ],
  },
  rgbToHex: {
    url: 'rgb-to-hex',
    title: 'Free RGB to HEX Converter - RGB Colors to Hex Codes',
    description: 'Free RGB to HEX converter by Codigrate. Enter red, green and blue values and instantly get the hex color code, with a live preview, a color picker and the math worked out step by step. RGB and HEX are the same color in two notations.',
    keywords: [
      'rgb to hex', 'rgb to hex converter', 'convert rgb to hex', 'rgb to hex color',
      'rgb to hex code', 'rgb to hexadecimal', 'rgb hex', 'color converter',
      'hex color code', 'rgb color', 'vibe coding', 'codigrate'
    ],
  },
  chromeColorPicker: {
    url: 'chrome/color-picker',
    title: 'Chrome Color Picker Extension - Eyedrop & Copy Web Colors',
    description: 'Codigrate\'s free Color Picker Chrome extension. Eyedrop any color on your screen and read it in every color space, with copy-ready CSS, WCAG and APCA contrast checks, harmonies, tints and shades and color vision simulations. Install from the Chrome Web Store.',
    keywords: [
      'chrome color picker', 'color picker', 'color picker extension', 'chrome extension',
      'eyedropper', 'eyedropper extension', 'screen color picker',
      'hex color', 'rgb color', 'hsl color', 'color converter', 'copy color code',
      'vibe coding', 'codigrate'
    ],
  },
  hexToHsl: {
    url: 'hex-to-hsl',
    title: 'Free HEX to HSL Converter - Hex Color Codes to HSL',
    description: 'Free HEX to HSL converter by Codigrate. Paste any hex color code and instantly get its hsl() value, with a live color preview, a picker and the math worked out step by step. HEX and HSL are the same color in two notations.',
    keywords: [
      'hex to hsl', 'hex to hsl converter', 'convert hex to hsl', 'hex code to hsl',
      'hexadecimal to hsl', 'hsl color', 'hue saturation lightness', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hslToHex: {
    url: 'hsl-to-hex',
    title: 'Free HSL to HEX Converter - HSL Colors to Hex Codes',
    description: 'Free HSL to HEX converter by Codigrate. Enter hue, saturation and lightness and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. HSL and HEX are the same color in two notations.',
    keywords: [
      'hsl to hex', 'hsl to hex converter', 'convert hsl to hex', 'hsl color',
      'hue saturation lightness', 'hex color code', 'hex color',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToHsv: {
    url: 'hex-to-hsv',
    title: 'Free HEX to HSV Converter - Hex Color Codes to HSV',
    description: 'Free HEX to HSV converter by Codigrate. Paste any hex color code and instantly get its HSV (HSB) value, with a live color preview, a picker and the math worked out step by step. HEX and HSV are the same color in two notations.',
    keywords: [
      'hex to hsv', 'hex to hsv converter', 'convert hex to hsv', 'hex to hsb',
      'hsv color', 'hsb color', 'hue saturation value', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hsvToHex: {
    url: 'hsv-to-hex',
    title: 'Free HSV to HEX Converter - HSV Colors to Hex Codes',
    description: 'Free HSV to HEX converter by Codigrate. Enter hue, saturation and value and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. HSV and HEX are the same color in two notations.',
    keywords: [
      'hsv to hex', 'hsv to hex converter', 'convert hsv to hex', 'hsb to hex',
      'hsv color', 'hsb color', 'hue saturation value', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToHsb: {
    url: 'hex-to-hsb',
    title: 'Free HEX to HSB Converter - Hex Color Codes to HSB',
    description: 'Free HEX to HSB converter by Codigrate. Paste any hex color code and instantly get its HSB (HSV) value, with a live color preview, a picker and the math worked out step by step. HEX and HSB are the same color in two notations.',
    keywords: [
      'hex to hsb', 'hex to hsb converter', 'convert hex to hsb', 'hex to hsv',
      'hsb color', 'hsv color', 'hue saturation brightness', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hsbToHex: {
    url: 'hsb-to-hex',
    title: 'Free HSB to HEX Converter - HSB Colors to Hex Codes',
    description: 'Free HSB to HEX converter by Codigrate. Enter hue, saturation and brightness and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. HSB and HEX are the same color in two notations.',
    keywords: [
      'hsb to hex', 'hsb to hex converter', 'convert hsb to hex', 'hsv to hex',
      'hsb color', 'hsv color', 'hue saturation brightness', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToHwb: {
    url: 'hex-to-hwb',
    title: 'Free HEX to HWB Converter - Hex Color Codes to HWB',
    description: 'Free HEX to HWB converter by Codigrate. Paste any hex color code and instantly get its hwb() value, with a live color preview, a picker and the math worked out step by step. HEX and HWB are the same color in two notations.',
    keywords: [
      'hex to hwb', 'hex to hwb converter', 'convert hex to hwb', 'hex code to hwb',
      'hwb color', 'hwb css', 'hue whiteness blackness', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hwbToHex: {
    url: 'hwb-to-hex',
    title: 'Free HWB to HEX Converter - HWB Colors to Hex Codes',
    description: 'Free HWB to HEX converter by Codigrate. Enter hue, whiteness and blackness and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. HWB and HEX are the same color in two notations.',
    keywords: [
      'hwb to hex', 'hwb to hex converter', 'convert hwb to hex', 'hwb color',
      'hwb css', 'hue whiteness blackness', 'hex color code', 'hex color',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToCmyk: {
    url: 'hex-to-cmyk',
    title: 'Free HEX to CMYK Converter - Hex Color Codes to CMYK',
    description: 'Free HEX to CMYK converter by Codigrate. Paste any hex color code and instantly get its CMYK ink values, with a live color preview, a picker and the math worked out step by step. HEX and CMYK are the same color in two notations.',
    keywords: [
      'hex to cmyk', 'hex to cmyk converter', 'convert hex to cmyk', 'hex code to cmyk',
      'cmyk color', 'cmyk values', 'cyan magenta yellow key', 'print color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  cmykToHex: {
    url: 'cmyk-to-hex',
    title: 'Free CMYK to HEX Converter - CMYK Colors to Hex Codes',
    description: 'Free CMYK to HEX converter by Codigrate. Enter cyan, magenta, yellow and key and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. CMYK and HEX are the same color in two notations.',
    keywords: [
      'cmyk to hex', 'cmyk to hex converter', 'convert cmyk to hex', 'cmyk color',
      'cmyk values', 'cyan magenta yellow key', 'print color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToOklch: {
    url: 'hex-to-oklch',
    title: 'Free HEX to OKLCH Converter - Hex Color Codes to OKLCH',
    description: 'Free HEX to OKLCH converter by Codigrate. Paste any hex color code and instantly get its OKLCH lightness, chroma and hue, with a live color preview, a picker and the math worked out step by step. HEX and OKLCH are the same color in two notations.',
    keywords: [
      'hex to oklch', 'hex to oklch converter', 'convert hex to oklch', 'hex code to oklch',
      'oklch color', 'oklch values', 'lightness chroma hue', 'perceptual color', 'css color 4', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  oklchToHex: {
    url: 'oklch-to-hex',
    title: 'Free OKLCH to HEX Converter - OKLCH Colors to Hex Codes',
    description: 'Free OKLCH to HEX converter by Codigrate. Enter OKLCH lightness, chroma and hue and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. OKLCH and HEX are the same color in two notations.',
    keywords: [
      'oklch to hex', 'oklch to hex converter', 'convert oklch to hex', 'oklch color',
      'oklch values', 'lightness chroma hue', 'perceptual color', 'css color 4', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToOklab: {
    url: 'hex-to-oklab',
    title: 'Free HEX to OKLAB Converter - Hex Color Codes to OKLAB',
    description: 'Free HEX to OKLAB converter by Codigrate. Paste any hex color code and instantly get its OKLAB lightness and a/b axes, with a live color preview, a picker and the math worked out step by step. HEX and OKLAB are the same color in two notations.',
    keywords: [
      'hex to oklab', 'hex to oklab converter', 'convert hex to oklab', 'hex code to oklab',
      'oklab color', 'oklab values', 'lightness a b', 'perceptual color', 'css color 4', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  oklabToHex: {
    url: 'oklab-to-hex',
    title: 'Free OKLAB to HEX Converter - OKLAB Colors to Hex Codes',
    description: 'Free OKLAB to HEX converter by Codigrate. Enter OKLAB lightness and the a and b axes and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. OKLAB and HEX are the same color in two notations.',
    keywords: [
      'oklab to hex', 'oklab to hex converter', 'convert oklab to hex', 'oklab color',
      'oklab values', 'lightness a b', 'perceptual color', 'css color 4', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToCielab: {
    url: 'hex-to-cielab',
    title: 'Free HEX to CIELAB Converter - Hex Color Codes to CIELAB',
    description: 'Free HEX to CIELAB converter by Codigrate. Paste any hex color code and instantly get its CIELAB lightness and a/b axes, with a live color preview, a picker and the math worked out step by step. HEX and CIELAB are the same color in two notations.',
    keywords: [
      'hex to cielab', 'hex to cielab converter', 'convert hex to cielab', 'hex code to cielab',
      'cielab color', 'cielab values', 'cie lab', 'lab color', 'lightness a b', 'perceptual color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  cielabToHex: {
    url: 'cielab-to-hex',
    title: 'Free CIELAB to HEX Converter - CIELAB Colors to Hex Codes',
    description: 'Free CIELAB to HEX converter by Codigrate. Enter CIELAB lightness and the a and b axes and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. CIELAB and HEX are the same color in two notations.',
    keywords: [
      'cielab to hex', 'cielab to hex converter', 'convert cielab to hex', 'cielab color',
      'cielab values', 'cie lab', 'lab color', 'lightness a b', 'perceptual color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToCielch: {
    url: 'hex-to-cielch',
    title: 'Free HEX to CIELCH Converter - Hex Color Codes to CIELCH',
    description: 'Free HEX to CIELCH converter by Codigrate. Paste any hex color code and instantly get its CIELCH lightness, chroma and hue, with a live color preview, a picker and the math worked out step by step. HEX and CIELCH are the same color in two notations.',
    keywords: [
      'hex to cielch', 'hex to cielch converter', 'convert hex to cielch', 'hex code to cielch',
      'cielch color', 'cielch values', 'cie lch', 'lch color', 'lightness chroma hue', 'perceptual color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  cielchToHex: {
    url: 'cielch-to-hex',
    title: 'Free CIELCH to HEX Converter - CIELCH Colors to Hex Codes',
    description: 'Free CIELCH to HEX converter by Codigrate. Enter CIELCH lightness, chroma and hue and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. CIELCH and HEX are the same color in two notations.',
    keywords: [
      'cielch to hex', 'cielch to hex converter', 'convert cielch to hex', 'cielch color',
      'cielch values', 'cie lch', 'lch color', 'lightness chroma hue', 'perceptual color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToCieluv: {
    url: 'hex-to-cieluv',
    title: 'Free HEX to CIELUV Converter - Hex Color Codes to CIELUV',
    description: 'Free HEX to CIELUV converter by Codigrate. Paste any hex color code and instantly get its CIELUV lightness and u/v axes, with a live color preview, a picker and the math worked out step by step. HEX and CIELUV are the same color in two notations.',
    keywords: [
      'hex to cieluv', 'hex to cieluv converter', 'convert hex to cieluv', 'hex code to cieluv',
      'cieluv color', 'cieluv values', 'cie luv', 'l*u*v*', 'cie 1976 luv', 'perceptual color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  cieluvToHex: {
    url: 'cieluv-to-hex',
    title: 'Free CIELUV to HEX Converter - CIELUV Colors to Hex Codes',
    description: 'Free CIELUV to HEX converter by Codigrate. Enter CIELUV lightness and u/v axes and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. CIELUV and HEX are the same color in two notations.',
    keywords: [
      'cieluv to hex', 'cieluv to hex converter', 'convert cieluv to hex', 'cieluv color',
      'cieluv values', 'cie luv', 'l*u*v*', 'cie 1976 luv', 'perceptual color', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToDisplayP3: {
    url: 'hex-to-display-p3',
    title: 'Free HEX to Display P3 Converter - Hex Color Codes to Display P3',
    description: 'Free HEX to Display P3 converter by Codigrate. Paste any hex color code and instantly get its Display P3 red, green and blue channels, with a live color preview, a picker and the math worked out step by step. HEX and Display P3 are the same color in two notations.',
    keywords: [
      'hex to display p3', 'hex to display p3 converter', 'convert hex to display p3', 'hex code to display p3',
      'display p3', 'display-p3', 'p3 color', 'wide gamut', 'css color()', 'color(display-p3)', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  displayP3ToHex: {
    url: 'display-p3-to-hex',
    title: 'Free Display P3 to HEX Converter - Display P3 Colors to Hex Codes',
    description: 'Free Display P3 to HEX converter by Codigrate. Enter Display P3 red, green and blue and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. Display P3 and HEX are the same color in two notations.',
    keywords: [
      'display p3 to hex', 'display p3 to hex converter', 'convert display p3 to hex',
      'display p3', 'display-p3', 'p3 color', 'wide gamut', 'css color()', 'color(display-p3)', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToXyz: {
    url: 'hex-to-xyz',
    title: 'Free HEX to XYZ Converter - Hex Color Codes to XYZ',
    description: 'Free HEX to XYZ converter by Codigrate. Paste any hex color code and instantly get its CIE XYZ tristimulus values, with a live color preview, a picker and the math worked out step by step. HEX and XYZ are the same color in two notations.',
    keywords: [
      'hex to xyz', 'hex to xyz converter', 'convert hex to xyz', 'hex code to xyz',
      'cie xyz', 'xyz color', 'tristimulus values', 'cie 1931', 'xyz d65', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  xyzToHex: {
    url: 'xyz-to-hex',
    title: 'Free XYZ to HEX Converter - XYZ Colors to Hex Codes',
    description: 'Free XYZ to HEX converter by Codigrate. Enter CIE XYZ tristimulus values and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. XYZ and HEX are the same color in two notations.',
    keywords: [
      'xyz to hex', 'xyz to hex converter', 'convert xyz to hex',
      'cie xyz', 'xyz color', 'tristimulus values', 'cie 1931', 'xyz d65', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToYxy: {
    url: 'hex-to-yxy',
    title: 'Free HEX to Yxy Converter - Hex Color Codes to Yxy',
    description: 'Free HEX to Yxy converter by Codigrate. Paste any hex color code and instantly get its CIE Yxy luminance and chromaticity coordinates, with a live color preview, a picker and the math worked out step by step. HEX and Yxy are the same color in two notations.',
    keywords: [
      'hex to yxy', 'hex to yxy converter', 'convert hex to yxy', 'hex code to yxy',
      'cie yxy', 'xyy color', 'chromaticity', 'chromaticity coordinates', 'cie 1931 diagram', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  yxyToHex: {
    url: 'yxy-to-hex',
    title: 'Free Yxy to HEX Converter - Yxy Colors to Hex Codes',
    description: 'Free Yxy to HEX converter by Codigrate. Enter CIE Yxy luminance and chromaticity and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. Yxy and HEX are the same color in two notations.',
    keywords: [
      'yxy to hex', 'yxy to hex converter', 'convert yxy to hex',
      'cie yxy', 'xyy color', 'chromaticity', 'chromaticity coordinates', 'cie 1931 diagram', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hexToHunterLab: {
    url: 'hex-to-hunter-lab',
    title: 'Free HEX to Hunter Lab Converter - Hex Color Codes to Hunter Lab',
    description: 'Free HEX to Hunter Lab converter by Codigrate. Paste any hex color code and instantly get its Hunter Lab lightness and a/b axes, with a live color preview, a picker and the math worked out step by step. HEX and Hunter Lab are the same color in two notations.',
    keywords: [
      'hex to hunter lab', 'hex to hunter lab converter', 'convert hex to hunter lab', 'hex code to hunter lab',
      'hunter lab', 'hunter l a b', 'hunterlab color', 'opponent color', 'color measurement', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  hunterLabToHex: {
    url: 'hunter-lab-to-hex',
    title: 'Free Hunter Lab to HEX Converter - Hunter Lab Colors to Hex Codes',
    description: 'Free Hunter Lab to HEX converter by Codigrate. Enter Hunter Lab lightness and a/b axes and get the hex color code instantly, with a live preview, a picker and the math worked out step by step. Hunter Lab and HEX are the same color in two notations.',
    keywords: [
      'hunter lab to hex', 'hunter lab to hex converter', 'convert hunter lab to hex',
      'hunter lab', 'hunter l a b', 'hunterlab color', 'opponent color', 'color measurement', 'hex color code',
      'color converter', 'vibe coding', 'codigrate'
    ],
  },
  jetbrainsColorPicker: {
    url: 'jetbrains/color-picker',
    title: 'JetBrains Color Picker Plugin - Eyedrop & Explore Colors in Your IDE',
    description: 'Codigrate\'s free Color Picker plugin for JetBrains IDEs. Eyedrop any color on your screen, copy it in every common color space, check WCAG and APCA contrast, and explore harmonies, tints and color vision simulations in one tool window. Install from the JetBrains Marketplace.',
    keywords: [
      'jetbrains color picker', 'color picker plugin', 'intellij color picker', 'jetbrains plugin',
      'eyedropper', 'ide color picker', 'screen color picker',
      'hex color', 'rgb color', 'oklch', 'wcag contrast', 'color converter', 'copy color code',
      'vibe coding', 'codigrate'
    ],
  },
  vscodeColorPicker: {
    url: 'vscode/color-picker',
    title: 'VS Code Color Picker Extension - Eyedrop & Explore Colors in Your Editor',
    description: 'Codigrate\'s free Color Picker extension for VS Code, Cursor and every editor built on them. Eyedrop any color on your screen or pick one up from your code, copy it in every common color space, check WCAG and APCA contrast, and explore harmonies, tints and color vision simulations in one side bar panel. Install from the VS Code Marketplace or Open VSX.',
    keywords: [
      'vs code color picker', 'vscode color picker', 'color picker extension', 'vs code extension', 'cursor color picker', 'open vsx',
      'eyedropper', 'editor color picker', 'screen color picker', 'hex color', 'rgb color', 'oklch', 'wcag contrast', 'apca',
      'color converter', 'copy color code', 'vibe coding', 'codigrate'
    ],
  },
  macosColorPicker: {
    url: 'macos/color-picker',
    title: 'macOS Color Picker App - Eyedrop & Explore Colors from Your Menu Bar',
    description: 'Codigrate\'s Color Picker app for macOS. Eyedrop any pixel on screen from the menu bar, then read every notation, WCAG and APCA contrast, harmonies, tints and color vision simulations. On the Mac App Store.',
    keywords: [
      'macos color picker', 'mac color picker', 'color picker app', 'menu bar app',
      'eyedropper', 'screen color picker', 'mac app store',
      'hex color', 'rgb color', 'oklch', 'wcag contrast', 'apca', 'color converter',
      'vibe coding', 'codigrate'
    ],
  },
  macosTidyDesktop: {
    url: 'macos/tidy-desktop',
    title: 'Tidy Desktop: AI Desktop Organizer for Mac',
    description: 'Organize your Mac desktop automatically. Tidy Desktop sorts files into Fences-style collections with Apple\'s on-device AI. Nothing moves or leaves your Mac.',
    keywords: [
      'mac desktop organizer', 'desktop organizer for mac', 'organize mac desktop', 'ai desktop organizer',
      'ai file organizer mac', 'fences for mac', 'fences alternative mac', 'declutter mac desktop',
      'clean up mac desktop', 'desktop collections', 'desktop icon groups mac', 'apple intelligence app',
      'on-device ai', 'tidy desktop', 'menu bar app', 'mac app store', 'codigrate'
    ],
  },
  // Tidy Desktop's privacy policy, under the app's page: /plugins/macos/tidy-desktop/privacy (the
  // url is the last two segments, as Dock Town's).
  macosTidyDesktopPrivacy: {
    url: 'tidy-desktop/privacy',
    title: 'Tidy Desktop Privacy Policy',
    description: 'Tidy Desktop collects no personal data: no account, analytics, ads or tracking. The app makes no network requests, your files never move, and Apple Intelligence runs on your Mac.',
    keywords: [ 'tidy desktop', 'privacy policy', 'mac app', 'no data collection', 'on-device ai' ],
  },
  macosDockTown: {
    url: 'macos/dock-town',
    title: 'Dock Town: Cozy Menu Bar System Monitor for Mac',
    description: 'A cozy town in your Mac\'s menu bar shows which app is using the CPU, memory and battery, and why your Mac is slow. Free, and it grows while you work.',
    keywords: [
      'dock town', 'menu bar system monitor', 'mac system monitor', 'cpu monitor mac', 'menu bar cpu monitor',
      'memory monitor mac', 'battery monitor mac', 'what is slowing down my mac', 'why is my mac slow',
      'which app is using cpu mac', 'battery drain mac', 'activity monitor alternative', 'cute system monitor',
      'cozy productivity app', 'productivity game mac', 'isometric town', 'menu bar app', 'mac app store', 'codigrate'
    ],
  },
  // Dock Town's privacy policy, under the app's page: /plugins/macos/dock-town/privacy. The url is
  // the last two segments of that path, the ones the SEO service resolves a route by (its last
  // one alone, 'privacy', is the dashboard's privacy page).
  macosDockTownPrivacy: {
    url: 'dock-town/privacy',
    title: 'Dock Town Privacy Policy',
    description: 'Dock Town collects no personal data: no account, analytics, ads or tracking. The app makes no network requests, and what it reads stays on your Mac.',
    keywords: [ 'dock town', 'privacy policy', 'mac app', 'no data collection' ],
  },
  macosAiTokenMeter: {
    url: 'macos/ai-token-meter',
    title: 'AI Token Meter: Claude Code and Codex Usage in Your Mac Menu Bar',
    description: 'See the tokens Claude Code, Codex and Antigravity CLI use and what they would cost at API prices, in your Mac menu bar: today, your limits, live sessions and history.',
    keywords: [
      'ai token meter', 'claude code usage', 'claude code token usage', 'codex usage', 'claude code cost',
      'token usage tracker', 'ai cost tracker', 'claude code limits', 'claude 5 hour limit', 'api cost calculator',
      'llm token counter', 'menu bar app', 'mac app', 'codigrate'
    ],
  },
  // Its privacy policy: /plugins/macos/ai-token-meter/privacy (the last two segments, as Dock Town's).
  macosAiTokenMeterPrivacy: {
    url: 'ai-token-meter/privacy',
    title: 'AI Token Meter Privacy Policy',
    description: 'AI Token Meter collects no personal data. It reads only token counts from your coding agents\' logs on your Mac, and its one request is the daily price list.',
    keywords: [ 'ai token meter', 'privacy policy', 'mac app', 'no data collection' ],
  },
  chromeAllInOneThemes: {
    url: 'chrome/all-in-one-themes',
    title: 'All In One Themes - Codigrate Chrome Themes Extension',
    description: 'Browse and apply Codigrate\'s Chrome themes from one popup. Twelve themes inspired by nature and iconic cities, from calm light palettes to deep dark ones, previewed and added to Chrome in one place. Free on the Chrome Web Store.',
    keywords: [
      'chrome themes', 'all in one themes', 'chrome extension', 'browser themes',
      'dark theme', 'light theme', 'nature themes', 'city themes',
      'aurora borealis theme', 'everest theme', 'codigrate themes',
      'vibe coding', 'codigrate'
    ],
  },

  // SplashLayout
  callback: {
    url: 'callback',
    title: 'Callback',
    description: 'Callback page',
    keywords: [ 'software business', 'software consultancy', 'callback' ],
  },
  dribbble: {
    url: 'dribbble',
    title: 'Dribbble',
    description: 'Connect with ' + BRAND.name + ' on Dribbble to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Dribbble' ],
  },
  facebook: {
    url: 'facebook',
    title: 'Facebook',
    description: 'Follow ' + BRAND.name + ' on Facebook to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Facebook' ],
  },
  github: {
    url: 'github',
    title: 'GitHub',
    description: 'Visit ' + BRAND.name + ' on GitHub to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'GitHub' ],
  },
  google: {
    url: 'google',
    title: 'Google',
    description: 'Find ' + BRAND.name + ' on Google to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Google' ],
  },
  linkedin: {
    url: 'linkedin',
    title: 'LinkedIn',
    description: 'Connect with ' + BRAND.name + ' on LinkedIn to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'LinkedIn' ],
  },
  reddit: {
    url: 'reddit',
    title: 'Reddit',
    description: 'Join ' + BRAND.name + ' on Reddit to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Reddit' ],
  },
  twitch: {
    url: 'twitch',
    title: 'Twitch',
    description: 'Follow ' + BRAND.name + ' on Twitch to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Twitch' ],
  },
  twitter: {
    url: 'twitter',
    title: 'Twitter',
    description: 'Follow ' + BRAND.name + ' on Twitter to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Twitter' ],
  },
  stripe: {
    url: 'stripe',
    title: 'Stripe',
    description: 'Connect with ' + BRAND.name + ' via Stripe to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'Stripe' ],
  },
  paypal: {
    url: 'paypal',
    title: 'PayPal',
    description: 'Connect with ' + BRAND.name + ' via PayPal to minimize your effort while building a new software business with our open source GitHub micro server templates and responsive web UI + mobile UI templates',
    keywords: [ 'software business', 'software consultancy', 'PayPal' ],
  },
  external: {
    url: 'external',
    title: 'External',
    description: 'External ',
    keywords: [ 'software business', 'software consultancy', 'external' ],
  },

  // Dashboard Layout
  dashboard: {
    url: 'dashboard',
    title: 'Dashboard',
    description: 'Access your dashboard at ' + BRAND.name + ' for managing your software business efficiently.',
    keywords: [ 'dashboard', 'management' ],
  },
  myProfile: {
    url: 'my-profile',
    title: 'My Profile',
    description: 'Manage your profile at ' + BRAND.name + ' to personalize your experience.',
    keywords: [ 'my profile', 'personalization' ],
  },
  privacy: {
    url: 'privacy',
    title: 'Privacy',
    description: 'Learn about the privacy practices of ' + BRAND.name + ' and how we protect your data.',
    keywords: [ 'privacy', 'data protection' ],
  },
  user: {
    url: 'user',
    title: 'User',
    description: 'Manage your user profile at ' + BRAND.name + ' for a personalized experience.',
    keywords: [ 'user profile', 'personalization' ],
  },
  settings: {
    url: 'settings',
    title: 'Settings',
    description: 'Adjust settings and preferences at ' + BRAND.name + ' to suit your needs.',
    keywords: [ 'settings', 'preferences' ],
  },
  editTheme: {
    url: 'edit-theme',
    title: 'Edit Theme',
    description: 'Customize the theme of your ' + BRAND.name + ' dashboard for a personalized look.',
    keywords: [ 'edit theme', 'customization' ],
  },
};

export const URLS = {
  // Landing layout
  root: '/',
  notFound: '/' + NAVIGATIONS.notFound.url,
  maintenance: '/' + NAVIGATIONS.maintenance.url,
  signupSuccess: '/' + NAVIGATIONS.signupSuccess.url,
  verifyAccount: '/' + NAVIGATIONS.verifyAccount.url,
  cookiePolicy: '/' + NAVIGATIONS.cookiePolicy.url,
  privacyPolicy: '/' + NAVIGATIONS.privacyPolicy.url,
  terms: '/' + NAVIGATIONS.terms.url,
  langmi: '/' + NAVIGATIONS.langmi.url,
  langmiPrivacy: '/' + NAVIGATIONS.langmiPrivacy.url,
  langmiTerms: '/' + NAVIGATIONS.langmiTerms.url,
  langmiTeacherTerms: '/' + NAVIGATIONS.langmiTeacherTerms.url,
  themeLicense: '/' + NAVIGATIONS.themeLicense.url,
  themePrivacy: '/' + NAVIGATIONS.themePrivacy.url,
  signup: '/' + NAVIGATIONS.signup.url,
  login: '/' + NAVIGATIONS.login.url,
  branding: '/' + NAVIGATIONS.branding.url,
  blog: '/' + NAVIGATIONS.blog.url,
  themes: '/' + NAVIGATIONS.themes.url,
  palettes: '/' + NAVIGATIONS.palettes.url,
  colorPalette: '/' + NAVIGATIONS.colorPalette.url,
  theme: '/' + NAVIGATIONS.theme.url,
  screenshots: '/' + NAVIGATIONS.screenshots.url,
  pinterest: '/' + NAVIGATIONS.pinterest.url,
  forgetPassword: '/' + NAVIGATIONS.forgetPassword.url,
  resetPassword: '/' + NAVIGATIONS.resetPassword.url,
  contactUs: '/' + NAVIGATIONS.contactUs.url,
  cart: '/' + NAVIGATIONS.cart.url,
  order: '/' + NAVIGATIONS.order.url,
  orderFind: '/' + NAVIGATIONS.orderFind.url,
  storeTerms: '/' + NAVIGATIONS.storeTerms.url,
  status: '/' + NAVIGATIONS.status.url,
  sitemap: '/' + NAVIGATIONS.sitemap.url,
  u: '/' + NAVIGATIONS.u.url,

  // ToolsLayout
  tools: {
    tools: '/' + NAVIGATIONS.tools.url,
    color: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.color.url,
    palette: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.palette.url,
    gradient: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.gradient.url,
    wallpaper: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.wallpaper.url,
    dynamicWallpaper: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.dynamicWallpaper.url,
    codeImage: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.codeImage.url,
    aiCostCalculator: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.aiCostCalculator.url,
    aiPriceWatch: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.aiPriceWatch.url,
    contrastChecker: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.contrastChecker.url,
    colorBlindnessSimulator: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.colorBlindnessSimulator.url,
    hexToRgb: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToRgb.url,
    rgbToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.rgbToHex.url,
    hexToHsl: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToHsl.url,
    hslToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hslToHex.url,
    hexToHsv: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToHsv.url,
    hsvToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hsvToHex.url,
    hexToHsb: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToHsb.url,
    hsbToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hsbToHex.url,
    hexToHwb: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToHwb.url,
    hwbToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hwbToHex.url,
    hexToCmyk: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToCmyk.url,
    cmykToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.cmykToHex.url,
    hexToOklch: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToOklch.url,
    oklchToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.oklchToHex.url,
    hexToOklab: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToOklab.url,
    oklabToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.oklabToHex.url,
    hexToCielab: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToCielab.url,
    cielabToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.cielabToHex.url,
    hexToCielch: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToCielch.url,
    cielchToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.cielchToHex.url,
    hexToCieluv: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToCieluv.url,
    cieluvToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.cieluvToHex.url,
    hexToDisplayP3: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToDisplayP3.url,
    displayP3ToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.displayP3ToHex.url,
    hexToXyz: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToXyz.url,
    xyzToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.xyzToHex.url,
    hexToYxy: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToYxy.url,
    yxyToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.yxyToHex.url,
    hexToHunterLab: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hexToHunterLab.url,
    hunterLabToHex: '/' + NAVIGATIONS.tools.url + '/' + NAVIGATIONS.hunterLabToHex.url,
  },

  // PluginsLayout
  plugins: {
    plugins: '/' + NAVIGATIONS.plugins.url,
    chromeColorPicker: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.chromeColorPicker.url,
    chromeAllInOneThemes: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.chromeAllInOneThemes.url,
    jetbrainsColorPicker: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.jetbrainsColorPicker.url,
    vscodeColorPicker: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.vscodeColorPicker.url,
    macosColorPicker: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosColorPicker.url,
    macosTidyDesktop: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosTidyDesktop.url,
    macosTidyDesktopPrivacy: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosTidyDesktop.url + '/privacy',
    macosDockTown: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosDockTown.url,
    macosDockTownPrivacy: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosDockTown.url + '/privacy',
    macosAiTokenMeter: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosAiTokenMeter.url,
    macosAiTokenMeterPrivacy: '/' + NAVIGATIONS.plugins.url + '/' + NAVIGATIONS.macosAiTokenMeter.url + '/privacy',
  },

  // SplashLayout
  callback: {
    root: '/' + NAVIGATIONS.callback.url,
    dribbble: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.dribbble.url,
    facebook: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.facebook.url,
    github: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.github.url,
    google: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.google.url,
    linkedin: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.linkedin.url,
    reddit: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.reddit.url,
    stripe: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.stripe.url,
    twitch: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.twitch.url,
    twitter: '/' + NAVIGATIONS.callback.url + '/' + NAVIGATIONS.twitter.url,
  },
  external: '/' + NAVIGATIONS.external.url,

  // Dashboard Layout
  dashboard: {
    root: '/' + NAVIGATIONS.dashboard.url,
    myProfile:
      '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.myProfile.url,
    privacy: '/' + NAVIGATIONS.dashboard.url + '/' + NAVIGATIONS.privacy.url,
  },
  user: {
    root: '/' + NAVIGATIONS.user.url,
  },

  // Settings Layout
  settings: {
    editTheme: '/' + NAVIGATIONS.settings.url + '/' + NAVIGATIONS.editTheme.url,
  },
};

